export enum NoticeDisplayStatus {
  DISPLAY = "노출 중",
  HIDE = "노출 안함",
}
